'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'stroopwafel';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f551';
var svgPathData = 'M256 16a240 240 0 1 0 0 480 240 240 0 1 0 0-480zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM131.5 120.2l56.6 56.6 56.6-56.6L210.7 86.3l-5.7-5.7 11.3-11.3 5.7 5.7L256 108.9 289.9 75l5.7-5.7 11.3 11.3-5.7 5.7-33.9 33.9 56.6 56.6 56.6-56.6 5.7-5.7 11.3 11.3-5.7 5.7-56.6 56.6 56.6 56.6 33.9-33.9 5.7-5.7 11.3 11.3-5.7 5.7L403.1 256 437 289.9l5.7 5.7-11.3 11.3-5.7-5.7-33.9-33.9-56.6 56.6 56.6 56.6 5.7 5.7-11.3 11.3-5.7-5.7-56.6-56.6-56.6 56.6 33.9 33.9 5.7 5.7-11.3 11.3-5.7-5.7L256 403.1 222.1 437l-5.7 5.7-11.3-11.3 5.7-5.7 33.9-33.9-56.6-56.6-56.6 56.6-5.7 5.7-11.3-11.3 5.7-5.7 56.6-56.6-56.6-56.6L86.3 301.3l-5.7 5.7L69.3 295.6l5.7-5.7L108.9 256 75 222.1l-5.7-5.7 11.3-11.3 5.7 5.7 33.9 33.9 56.6-56.6-56.6-56.6-5.7-5.7 11.3-11.3 5.7 5.7zm0 135.8l56.6 56.6L244.7 256l-56.6-56.6L131.5 256zm67.9 67.9L256 380.5l56.6-56.6L256 267.3l-56.6 56.6zm181-67.9l-56.6-56.6L267.3 256l56.6 56.6L380.5 256zM256 244.7l56.6-56.6L256 131.5l-56.6 56.6L256 244.7z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faStroopwafel = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;